import {AbstractModel} from "./abstract-model";
import {User} from './user';

export class Config extends AbstractModel {
  user: User | null = null;
  roles: string[] = [];
  data: any;
  currency: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    return this;
  }
}
